import { Navigate, useLocation } from 'react-router-dom';
import { normalizeRole } from '@/auth/permissions';
import { clearSession, getSession } from '@/lib/session';

type RequireRhDocumentRoleProps = {
  mode: 'employee' | 'admin';
  children: JSX.Element;
};

const EMPLOYEE_SIGNER_ROLES = new Set(['GERENTE_INV', 'SUPERVISOR', 'ALMACENISTA', 'OFICINA', 'RH', 'VENTAS_INTERNAS', 'GERENTE_LOGISTICA', 'MKT', 'OPERADOR', 'VENDEDOR']);

export function RequireRhDocumentRole({ mode, children }: RequireRhDocumentRoleProps) {
  const location = useLocation();
  const session = typeof window !== 'undefined' ? getSession() : null;

  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') {
      clearSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = normalizeRole(session.user.role);

  if (role === 'CONSULTA') {
    return <Navigate to="/inventario" replace />;
  }

  if (mode === 'admin') {
    return role === 'ADMIN' || role === 'RH' ? children : <Navigate to="/documentos-por-firmar" replace />;
  }

  if (role === 'ADMIN' || role === 'RH') {
    return <Navigate to="/admin/rh/documentos" replace />;
  }
  if (!EMPLOYEE_SIGNER_ROLES.has(role)) {
    return <Navigate to="/asistencia" replace />;
  }
  return children;
}

export function RhDocumentsRedirect() {
  const location = useLocation();
  const session = typeof window !== 'undefined' ? getSession() : null;
  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') {
      clearSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  const role = normalizeRole(session.user.role);
  if (role === 'CONSULTA') {
    return <Navigate to="/inventario" replace />;
  }
  if (role === 'ADMIN') {
    return <Navigate to="/admin/rh/documentos" replace />;
  }
  return <Navigate to="/documentos-por-firmar" replace />;
}
